export const comics = [
  {
    id: 1,
    slug: 'dushi-jue-qi',
    title: '都市崛起',
    author: '金秀贤',
    category: '都市',
    rating: 9.5,
    ratingCount: 12850,
    description: '在繁华都市的底层，一个平凡少年凭借坚韧不拔的意志，一步步走向人生巅峰。这是一部关于成长、奋斗与逆袭的励志韩漫，画面细腻写实，剧情扣人心弦。',
    detailedDescription: '在繁华都市的底层，一个平凡少年凭借坚韧不拔的意志，一步步走向人生巅峰。这是一部关于成长、奋斗与逆袭的励志韩漫。作品以细腻的笔触刻画了主角从一无所有到功成名就的蜕变过程，每一个转折都令人热血沸腾。画风写实大气，场景渲染极具代入感，人物情感表达丰富而真实。无论你是职场新人还是正在奋斗路上的追梦人，这部作品都能给你带来强烈的共鸣与激励。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20young%20man%20in%20modern%20city%20setting%2C%20dramatic%20lighting%2C%20clean%20illustration%20style%2C%20warm%20amber%20and%20charcoal%20tones%2C%20professional%20digital%20art%2C%20cinematic%20composition%2C%20minimal%20background%20with%20soft%20gradient&width=800&height=1100&seq=comic-cover-01&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20manhwa%20webtoon%20banner%2C%20modern%20cityscape%20at%20sunset%2C%20warm%20golden%20and%20deep%20charcoal%20color%20palette%2C%20abstract%20geometric%20patterns%2C%20soft%20gradients%2C%20clean%20and%20minimal%20aesthetic%2C%20professional%20digital%20art%2C%20no%20text%2C%20atmospheric%20lighting&width=1600&height=700&seq=comic-banner-01&orientation=landscape',
    chapters: 186,
    status: '连载中',
    isHot: true,
    isNew: false,
    tags: ['热血', '职场', '逆袭'],
    updateTime: '2026-07-02',
  },
  {
    id: 2,
    slug: 'ai-qing-mi-ma',
    title: '爱情密码',
    author: '李智慧',
    category: '恋爱',
    rating: 9.3,
    ratingCount: 9520,
    description: '两个素未谋面的陌生人，因为一条错误的短信开始了一段奇妙的缘分。甜蜜又治愈的都市爱情故事，让人相信命中注定的邂逅。',
    detailedDescription: '两个素未谋面的陌生人，因为一条错误的短信开始了一段奇妙的缘分。这是一部甜蜜又治愈的都市爱情故事。作者以温柔细腻的笔触描绘了现代人在繁华都市中的孤独与渴望，以及那份不经意间降临的爱情。画面清新唯美，人物表情生动自然，每一个互动都充满心动感。读者纷纷表示"看完让人想谈恋爱"，是韩漫爱情类中不可多得的佳作。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20art%2C%20young%20couple%20in%20romantic%20scene%2C%20soft%20pastel%20pink%20and%20warm%20beige%20tones%2C%20clean%20illustration%20style%2C%20dreamy%20atmosphere%2C%20minimal%20background%20with%20soft%20gradient%2C%20professional%20digital%20art&width=800&height=1100&seq=comic-cover-02&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20romance%20webtoon%20banner%2C%20soft%20pink%20and%20warm%20beige%20color%20palette%2C%20abstract%20flowing%20shapes%2C%20dreamy%20atmosphere%2C%20minimal%20aesthetic%2C%20professional%20digital%20art%2C%20no%20text%2C%20gentle%20gradients&width=1600&height=700&seq=comic-banner-02&orientation=landscape',
    chapters: 142,
    status: '连载中',
    isHot: true,
    isNew: false,
    tags: ['恋爱', '治愈', '都市'],
    updateTime: '2026-07-01',
  },
  {
    id: 3,
    slug: 'an-ying-lie-ren',
    title: '暗影猎人',
    author: '朴志勋',
    category: '奇幻',
    rating: 9.7,
    ratingCount: 15630,
    description: '在一个被黑暗势力笼罩的世界里，一群拥有特殊能力的猎人与恶魔展开殊死搏斗。宏大的世界观、精彩的战斗场面，堪称韩漫奇幻类的巅峰之作。',
    detailedDescription: '在一个被黑暗势力笼罩的世界里，一群拥有特殊能力的猎人与恶魔展开殊死搏斗。这部作品以宏大的世界观和精彩的战斗场面著称，被誉为韩漫奇幻类的巅峰之作。作者构建了一个完整的超自然体系，每个角色都有鲜明的个性和动人的背景故事。画面张力十足，动作场景流畅震撼，色彩运用极具视觉冲击力。如果你喜欢热血战斗与奇幻冒险，这部作品绝对不容错过。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%20art%2C%20dark%20hunter%20character%20with%20sword%2C%20dramatic%20red%20and%20charcoal%20tones%2C%20clean%20illustration%20style%2C%20mysterious%20atmosphere%2C%20minimal%20dark%20background%20with%20soft%20gradient%2C%20professional%20digital%20art&width=800&height=1100&seq=comic-cover-03&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20fantasy%20webtoon%20banner%2C%20dark%20crimson%20and%20charcoal%20color%20palette%2C%20abstract%20smoke%20and%20shadow%20patterns%2C%20mysterious%20atmosphere%2C%20minimal%20aesthetic%2C%20professional%20digital%20art%2C%20no%20text%2C%20dramatic%20lighting&width=1600&height=700&seq=comic-banner-03&orientation=landscape',
    chapters: 210,
    status: '连载中',
    isHot: true,
    isNew: false,
    tags: ['奇幻', '战斗', '热血'],
    updateTime: '2026-06-30',
  },
  {
    id: 4,
    slug: 'xing-kong-zhi-xia',
    title: '星空之下',
    author: '崔恩熙',
    category: '治愈',
    rating: 9.4,
    ratingCount: 7890,
    description: '一个失去记忆的少女，在一个海边小镇重新开始生活。温暖治愈的日常故事，每一页都洋溢着阳光与海风的气息。',
    detailedDescription: '一个失去记忆的少女，在一个海边小镇重新开始生活。这是一部温暖治愈的日常故事，每一页都洋溢着阳光与海风的气息。作者以极其细腻的笔触描绘了小镇的四季变换与人情冷暖，让读者仿佛身临其境。角色的成长弧线自然流畅，情感表达含蓄而深刻。那些看似平凡的日常瞬间，在作者的笔下变得格外动人。适合在疲惫时翻开，让心灵得到片刻的安宁与慰藉。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20healing%20manhwa%20cover%20art%2C%20girl%20by%20the%20seaside%2C%20soft%20blue%20and%20warm%20cream%20tones%2C%20clean%20illustration%20style%2C%20peaceful%20atmosphere%2C%20minimal%20background%20with%20soft%20gradient%2C%20professional%20digital%20art&width=800&height=1100&seq=comic-cover-04&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20healing%20webtoon%20banner%2C%20seaside%20sunset%20color%20palette%2C%20soft%20blue%20and%20warm%20cream%20tones%2C%20abstract%20wave%20patterns%2C%20peaceful%20atmosphere%2C%20minimal%20aesthetic%2C%20professional%20digital%20art%2C%20no%20text%2C%20gentle%20gradients&width=1600&height=700&seq=comic-banner-04&orientation=landscape',
    chapters: 98,
    status: '已完结',
    isHot: false,
    isNew: true,
    tags: ['治愈', '日常', '温情'],
    updateTime: '2026-07-03',
  },
  {
    id: 5,
    slug: 'quan-li-you-xi',
    title: '权力游戏',
    author: '郑宇成',
    category: '悬疑',
    rating: 9.6,
    ratingCount: 11200,
    description: '政治阴谋、权力斗争、背叛与复仇，一部让人欲罢不能的悬疑大作。每个角色都深藏秘密，每页都充满反转。',
    detailedDescription: '政治阴谋、权力斗争、背叛与复仇——一部让人欲罢不能的悬疑大作。故事围绕韩国顶级财阀家族的内部斗争展开，每个角色都深藏秘密，每一页都充满意想不到的反转。作者以缜密的逻辑和精准的节奏把控，编织出一个令人窒息的权力迷宫。画风冷峻写实，人物神态刻画入木三分，暗色调的画面完美烘托了悬疑氛围。如果你喜欢烧脑剧情和复杂的人物关系，这部作品一定会让你上瘾。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20manhwa%20cover%20art%2C%20intense%20character%20in%20suit%2C%20dark%20navy%20and%20silver%20tones%2C%20clean%20illustration%20style%2C%20mysterious%20atmosphere%2C%20minimal%20dark%20background%20with%20soft%20gradient%2C%20professional%20digital%20art&width=800&height=1100&seq=comic-cover-05&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20thriller%20webtoon%20banner%2C%20dark%20navy%20and%20silver%20color%20palette%2C%20abstract%20geometric%20sharp%20patterns%2C%20mysterious%20atmosphere%2C%20minimal%20aesthetic%2C%20professional%20digital%20art%2C%20no%20text%2C%20dramatic%20contrast&width=1600&height=700&seq=comic-banner-05&orientation=landscape',
    chapters: 175,
    status: '连载中',
    isHot: true,
    isNew: false,
    tags: ['悬疑', '权谋', '反转'],
    updateTime: '2026-07-02',
  },
  {
    id: 6,
    slug: 'xiao-yuan-mi-yu',
    title: '校园密语',
    author: '尹素熙',
    category: '校园',
    rating: 9.2,
    ratingCount: 6340,
    description: '高中校园里的青春故事，友情、暗恋、梦想交织在一起。清新自然的画风，真实动人的情感，带你回到最美好的学生时代。',
    detailedDescription: '高中校园里的青春故事，友情、暗恋、梦想交织在一起。这部作品以清新自然的画风和真实动人的情感描绘，带你回到最美好的学生时代。作者巧妙地捕捉了青春期的每一个细微情感——那些欲言又止的告白、课间走廊的擦肩而过、放学后一起走过的路。角色设计讨喜，剧情节奏轻快，既有让人会心一笑的甜蜜，也有让人感同身受的成长烦恼。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20school%20manhwa%20cover%20art%2C%20students%20in%20school%20uniform%2C%20fresh%20mint%20green%20and%20warm%20cream%20tones%2C%20clean%20illustration%20style%2C%20youthful%20atmosphere%2C%20minimal%20background%20with%20soft%20gradient%2C%20professional%20digital%20art&width=800&height=1100&seq=comic-cover-06&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20school%20youth%20webtoon%20banner%2C%20fresh%20mint%20green%20and%20warm%20cream%20color%20palette%2C%20abstract%20soft%20waves%2C%20youthful%20atmosphere%2C%20minimal%20aesthetic%2C%20professional%20digital%20art%2C%20no%20text%2C%20gentle%20gradients&width=1600&height=700&seq=comic-banner-06&orientation=landscape',
    chapters: 88,
    status: '已完结',
    isHot: false,
    isNew: true,
    tags: ['校园', '青春', '恋爱'],
    updateTime: '2026-07-03',
  },
  {
    id: 7,
    slug: 'mo-jie-jiang-lin',
    title: '魔界降临',
    author: '金成勋',
    category: '奇幻',
    rating: 9.5,
    ratingCount: 10450,
    description: '当魔界的裂缝在地球上打开，普通游戏玩家成为了拯救世界的唯一希望。融合了游戏元素与奇幻冒险的精彩作品。',
    detailedDescription: '当魔界的裂缝在地球上打开，普通游戏玩家成为了拯救世界的唯一希望。这部作品巧妙融合了游戏元素与奇幻冒险，创造出独一无二的阅读体验。主角通过类似RPG游戏的升级系统不断变强，每一次战斗都充满策略与惊喜。画面表现力极强，怪物设计新颖独特，技能特效绚丽夺目。世界观层层展开，让人欲罢不能。是近年来韩漫中游戏奇幻类的标杆之作。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20game%20manhwa%20cover%20art%2C%20warrior%20with%20magic%20effects%2C%20deep%20purple%20and%20gold%20tones%2C%20clean%20illustration%20style%2C%20epic%20atmosphere%2C%20minimal%20dark%20background%20with%20soft%20gradient%2C%20professional%20digital%20art&width=800&height=1100&seq=comic-cover-07&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20fantasy%20game%20webtoon%20banner%2C%20deep%20purple%20and%20gold%20color%20palette%2C%20abstract%20portal%20patterns%2C%20epic%20atmosphere%2C%20minimal%20aesthetic%2C%20professional%20digital%20art%2C%20no%20text%2C%20dramatic%20lighting&width=1600&height=700&seq=comic-banner-07&orientation=landscape',
    chapters: 198,
    status: '连载中',
    isHot: true,
    isNew: false,
    tags: ['奇幻', '游戏', '战斗'],
    updateTime: '2026-07-01',
  },
  {
    id: 8,
    slug: 'mei-shi-tian-tang',
    title: '美食天堂',
    author: '朴美英',
    category: '美食',
    rating: 9.1,
    ratingCount: 5210,
    description: '一位天才厨师在竞争激烈的美食界中闯荡的故事。每一话都是一场视觉与味觉的盛宴，让人看得饥肠辘辘的韩漫佳作。',
    detailedDescription: '一位天才厨师在竞争激烈的美食界中闯荡的故事。这部作品堪称视觉与味觉的双重盛宴——每一话中精心绘制的美食都令人垂涎欲滴，仿佛能透过屏幕闻到香气。作者对料理过程的描绘细致入微，对食材的刻画充满敬意。剧情方面，既有厨艺比拼的紧张刺激，也有温暖人心的美食故事。角色之间的羁绊通过一道道料理逐渐加深，让人感受到食物连接人心的力量。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20cooking%20food%20manhwa%20cover%20art%2C%20chef%20with%20beautiful%20dish%2C%20warm%20orange%20and%20cream%20tones%2C%20clean%20illustration%20style%2C%20appetizing%20atmosphere%2C%20minimal%20background%20with%20soft%20gradient%2C%20professional%20digital%20art&width=800&height=1100&seq=comic-cover-08&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20food%20cooking%20webtoon%20banner%2C%20warm%20orange%20and%20cream%20color%20palette%2C%20abstract%20steam%20and%20spice%20patterns%2C%20appetizing%20atmosphere%2C%20minimal%20aesthetic%2C%20professional%20digital%20art%2C%20no%20text%2C%20gentle%20gradients&width=1600&height=700&seq=comic-banner-08&orientation=landscape',
    chapters: 76,
    status: '连载中',
    isHot: false,
    isNew: true,
    tags: ['美食', '竞技', '治愈'],
    updateTime: '2026-07-03',
  },
  {
    id: 9,
    slug: 'chuan-yue-yi-shi-jie',
    title: '穿越异世界',
    author: '金泰亨',
    category: '穿越',
    rating: 9.4,
    ratingCount: 8920,
    description: '一场意外让普通上班族穿越到剑与魔法的世界。凭借现代人的智慧与知识，他在异世界掀起了一场前所未有的变革。',
    detailedDescription: '一场意外让普通上班族穿越到剑与魔法的世界。凭借现代人的智慧与知识，主角在异世界掀起了一场前所未有的变革。这部作品的最大魅力在于主角并非靠蛮力取胜，而是运用经济学、管理学等现代知识体系，在异世界建立起全新的秩序。故事节奏明快，笑点密集的同时又不失深度。画风精致，异世界的场景设计充满想象力。在众多穿越题材韩漫中，这部的独特视角令人耳目一新。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20isekai%20manhwa%20cover%20art%2C%20character%20in%20fantasy%20world%20with%20magic%2C%20vibrant%20teal%20and%20gold%20tones%2C%20clean%20illustration%20style%2C%20adventure%20atmosphere%2C%20minimal%20background%20with%20soft%20gradient%2C%20professional%20digital%20art&width=800&height=1100&seq=comic-cover-09&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20isekai%20fantasy%20webtoon%20banner%2C%20vibrant%20teal%20and%20gold%20color%20palette%2C%20abstract%20portal%20and%20magic%20patterns%2C%20adventure%20atmosphere%2C%20minimal%20aesthetic%2C%20professional%20digital%20art%2C%20no%20text%2C%20dramatic%20lighting&width=1600&height=700&seq=comic-banner-09&orientation=landscape',
    chapters: 156,
    status: '连载中',
    isHot: true,
    isNew: false,
    tags: ['穿越', '奇幻', '智斗'],
    updateTime: '2026-06-29',
  },
  {
    id: 10,
    slug: 'kong-bu-yi-yuan',
    title: '恐怖医院',
    author: '李秀贤',
    category: '恐怖',
    rating: 9.0,
    ratingCount: 4780,
    description: '一所废弃多年的医院里，隐藏着令人毛骨悚然的秘密。深夜值班的保安逐渐发现，这里并非空无一人……',
    detailedDescription: '一所废弃多年的医院里，隐藏着令人毛骨悚然的秘密。深夜值班的保安逐渐发现，这里并非空无一人……这是一部真正能让人后背发凉的恐怖韩漫。作者对恐怖氛围的营造堪称大师级别——通过精心设计的画面构图、光影对比和节奏控制，让恐惧感层层递进。没有廉价的血腥惊吓，而是靠心理悬疑和细思极恐的情节让人不寒而栗。建议白天阅读，夜晚慎入。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20horror%20manhwa%20cover%20art%2C%20eerie%20hospital%20corridor%2C%20cold%20green%20and%20dark%20gray%20tones%2C%20clean%20illustration%20style%2C%20creepy%20atmosphere%2C%20minimal%20dark%20background%20with%20soft%20gradient%2C%20professional%20digital%20art&width=800&height=1100&seq=comic-cover-10&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20horror%20webtoon%20banner%2C%20cold%20green%20and%20dark%20gray%20color%20palette%2C%20abstract%20shadow%20patterns%2C%20eerie%20atmosphere%2C%20minimal%20aesthetic%2C%20professional%20digital%20art%2C%20no%20text%2C%20dramatic%20contrast&width=1600&height=700&seq=comic-banner-10&orientation=landscape',
    chapters: 64,
    status: '已完结',
    isHot: false,
    isNew: false,
    tags: ['恐怖', '悬疑', '惊悚'],
    updateTime: '2026-06-15',
  },
  {
    id: 11,
    slug: 'ti-yu-feng-yun',
    title: '体育风云',
    author: '姜东元',
    category: '体育',
    rating: 9.3,
    ratingCount: 6890,
    description: '一群热爱篮球的高中生，为了全国大赛的梦想挥洒汗水与青春。热血激昂的体育竞技漫画，让人感受到团队的力量。',
    detailedDescription: '一群热爱篮球的高中生，为了全国大赛的梦想挥洒汗水与青春。这是一部热血激昂的体育竞技韩漫，每一个比赛场景都让人肾上腺素飙升。作者对篮球动作的描绘专业而流畅，仿佛能感受到球场上每一次运球和投篮的力度。除了精彩的比赛，作品对团队情谊和个人成长的刻画同样深刻动人。从冲突到信任，从失败到崛起，这支球队的每一步都牵动着读者的心。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20sports%20basketball%20manhwa%20cover%20art%2C%20athlete%20in%20action%2C%20vibrant%20orange%20and%20navy%20tones%2C%20clean%20illustration%20style%2C%20energetic%20atmosphere%2C%20minimal%20background%20with%20soft%20gradient%2C%20professional%20digital%20art&width=800&height=1100&seq=comic-cover-11&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20sports%20basketball%20webtoon%20banner%2C%20vibrant%20orange%20and%20navy%20color%20palette%2C%20abstract%20motion%20lines%2C%20energetic%20atmosphere%2C%20minimal%20aesthetic%2C%20professional%20digital%20art%2C%20no%20text%2C%20dynamic%20composition&width=1600&height=700&seq=comic-banner-11&orientation=landscape',
    chapters: 120,
    status: '连载中',
    isHot: false,
    isNew: false,
    tags: ['体育', '热血', '青春'],
    updateTime: '2026-06-28',
  },
  {
    id: 12,
    slug: 'li-shi-zhang-juan',
    title: '历史长卷',
    author: '崔明秀',
    category: '历史',
    rating: 9.6,
    ratingCount: 7340,
    description: '以朝鲜时代为背景的史诗级历史漫画。宫廷斗争、家国情怀、儿女情长，一幅波澜壮阔的历史画卷徐徐展开。',
    detailedDescription: '以朝鲜时代为背景的史诗级历史漫画。宫廷斗争、家国情怀、儿女情长——一幅波澜壮阔的历史画卷徐徐展开。作者对历史细节的考据极为严谨，服饰、建筑、礼仪都经过精心还原。剧情在真实历史框架下展开虚构故事，既有宏大的时代背景，也有细腻的人物刻画。画风典雅大气，水墨风格的渲染让整部作品充满东方美学韵味。是韩漫历史题材中不可多得的精品。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20historical%20manhwa%20cover%20art%2C%20traditional%20Korean%20costume%20character%2C%20elegant%20jade%20green%20and%20warm%20ochre%20tones%2C%20clean%20illustration%20style%2C%20classical%20atmosphere%2C%20minimal%20background%20with%20soft%20gradient%2C%20professional%20digital%20art&width=800&height=1100&seq=comic-cover-12&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20historical%20webtoon%20banner%2C%20elegant%20jade%20green%20and%20warm%20ochre%20color%20palette%2C%20abstract%20traditional%20patterns%2C%20classical%20atmosphere%2C%20minimal%20aesthetic%2C%20professional%20digital%20art%2C%20no%20text%2C%20gentle%20gradients&width=1600&height=700&seq=comic-banner-12&orientation=landscape',
    chapters: 168,
    status: '连载中',
    isHot: false,
    isNew: false,
    tags: ['历史', '宫廷', '史诗'],
    updateTime: '2026-07-02',
  },
];

export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'dushi', name: '都市', icon: 'ri-building-line' },
  { slug: 'lianai', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'qihuan', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'zhiyu', name: '治愈', icon: 'ri-mental-health-line' },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'xiaoyuan', name: '校园', icon: 'ri-school-line' },
  { slug: 'meishi', name: '美食', icon: 'ri-restaurant-line' },
  { slug: 'chuanyue', name: '穿越', icon: 'ri-rocket-line' },
  { slug: 'kongbu', name: '恐怖', icon: 'ri-ghost-line' },
  { slug: 'tiyu', name: '体育', icon: 'ri-basketball-line' },
  { slug: 'lishi', name: '历史', icon: 'ri-ancient-gate-line' },
];

export const features = [
  {
    icon: 'ri-smartphone-line',
    title: '下拉式阅读',
    description: '专为移动端优化的下拉式阅读体验，无需翻页，一滑到底，让阅读行云流水般流畅自然。',
  },
  {
    icon: 'ri-check-double-line',
    title: '无删减内容',
    description: '所有漫画均为韩国官方正版授权，保证内容完整无删减，原汁原味呈现每一部作品的精彩。',
  },
  {
    icon: 'ri-translate',
    title: '专业汉化',
    description: '资深翻译团队用心打磨每一个细节，确保中文版本既忠实原著又符合中文阅读习惯。',
  },
  {
    icon: 'ri-book-open-line',
    title: '海量资源',
    description: '涵盖都市、恋爱、奇幻、悬疑等十余个品类，超过千部精品韩漫持续更新，总有一部适合你。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速加载',
    description: '采用先进的图片压缩与CDN加速技术，确保每一话都能秒速加载，告别等待的烦恼。',
  },
  {
    icon: 'ri-heart-add-line',
    title: '个性化推荐',
    description: '智能算法根据你的阅读偏好精准推荐，帮你发现更多符合口味的优质韩漫作品。',
  },
];

export const testimonials = [
  {
    name: '漫画迷小王',
    role: '3年老用户',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimal%20avatar%20portrait%20of%20a%20young%20Asian%20man%2C%20clean%20background%2C%20soft%20lighting%2C%20professional%20headshot%20style&width=120&height=120&seq=avatar-01&orientation=squarish',
    rating: 5,
    text: '用了36漫画网三年了，画质清晰、更新速度快，而且真的是无删减版，比其他平台良心太多了！推荐给了身边所有喜欢韩漫的朋友。',
  },
  {
    name: '追更达人小李',
    role: 'VIP用户',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimal%20avatar%20portrait%20of%20a%20young%20Asian%20woman%2C%20clean%20background%2C%20soft%20lighting%2C%20professional%20headshot%20style&width=120&height=120&seq=avatar-02&orientation=squarish',
    rating: 5,
    text: '下拉式阅读体验真的太棒了！通勤路上单手就能看，不用翻页的操作让沉浸在剧情里更加自然。内容库也越来越丰富，每天都有新惊喜。',
  },
  {
    name: '资深漫友阿杰',
    role: '漫画博主',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimal%20avatar%20portrait%20of%20a%20young%20Asian%20man%20with%20glasses%2C%20clean%20background%2C%20soft%20lighting%2C%20professional%20headshot%20style&width=120&height=120&seq=avatar-03&orientation=squarish',
    rating: 5,
    text: '作为漫画博主，我用过不下十个平台，36漫画网的汉化质量是最高的。翻译不仅准确，还能保留原作的语气和情感，这点真的很难得。',
  },
];

export const faqs = [
  {
    question: '36漫画网上的韩漫都是无删减版本吗？',
    answer: '是的，36漫画网上的所有韩国漫画均为无删减正版内容。我们与韩国多家漫画平台建立了合作关系，确保每一部作品的完整性和原汁原味。您在这里看到的每一话都与韩国原版保持完全一致。',
  },
  {
    question: '什么是下拉式阅读？如何使用？',
    answer: '下拉式阅读是一种专为移动端优化的漫画阅读方式。您只需向上滑动屏幕，漫画内容就会像网页一样连续向下滚动，无需点击翻页按钮。这种方式让阅读体验更加流畅自然，尤其是在手机上单手操作时非常方便。',
  },
  {
    question: '36漫画网是否免费？',
    answer: '36漫画网提供大量免费韩漫内容，您无需注册即可阅读大部分作品的前几个章节。对于最新更新和热门作品，我们提供多种获取方式，包括每日签到奖励、观看广告获取阅读券等，让您以最低的成本享受最优质的韩漫内容。',
  },
  {
    question: '多久更新一次漫画？',
    answer: '大部分热门连载漫画保持每周更新的频率，通常在每周固定时间（如周三或周五）更新。具体更新时间和频率因作品而异，您可以在每部漫画的详情页查看最新的更新时间。已完结作品的全部章节均可一次性阅读。',
  },
  {
    question: '是否支持离线下载阅读？',
    answer: '目前我们正在开发离线下载功能，预计将在下一个版本中推出。届时您可以将喜欢的漫画章节下载到本地，在没有网络的情况下也能畅快阅读。请关注我们的更新公告获取最新动态。',
  },
  {
    question: '如何找到我喜欢的漫画类型？',
    answer: '您可以通过首页的分类导航快速跳转到感兴趣的漫画类型，也可以使用搜索功能输入漫画名称或作者进行查找。此外，我们的智能推荐系统会根据您的阅读历史和偏好，为您推荐可能感兴趣的韩漫作品。',
  },
];

export const aboutInfo = {
  brandName: '36漫画网',
  tagline: '让每一部韩漫，都被完整看见',
  introduction: '36漫画网创立于2020年，是国内领先的韩国漫画在线阅读平台。我们致力于为中文读者提供最优质、最完整的韩漫阅读体验。从最初的几十部作品起步，如今已发展成为拥有上千部精品韩漫的综合平台，涵盖都市、恋爱、奇幻、悬疑、校园、美食、穿越、恐怖、体育、历史等十余个品类。',
  mission: '我们的使命是打破语言与文化的壁垒，让每一位中文读者都能无障碍地享受韩国漫画的魅力。我们坚持"无删减、高品质、快更新"三大原则，与韩国多家顶级漫画平台和出版社建立了深度合作关系，确保内容的正版性与完整性。',
  advantages: [
    {
      icon: 'ri-shield-check-line',
      title: '正版授权',
      description: '所有作品均获得韩国官方授权，支持正版漫画产业发展，让每一次阅读都心安理得。',
    },
    {
      icon: 'ri-team-line',
      title: '专业团队',
      description: '拥有经验丰富的中韩双语翻译团队和编辑团队，确保汉化质量达到出版级水准。',
    },
    {
      icon: 'ri-flashlight-line',
      title: '技术领先',
      description: '自研的图片优化引擎和CDN加速网络，确保最佳的加载速度和阅读流畅度。',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '优质服务',
      description: '7×24小时客服支持，用户反馈快速响应，持续优化产品体验。',
    },
  ],
  contactEmail: 'hello@jhequip.com',
  contactWechat: 'manhua36official',
  contactQQ: '1234567890',
};